import { Tooltip } from "react-tooltip"; // Componente externo para tooltips
import { TooltipCss } from '../components/styles'; // Estilos personalizados

// Props que acepta el componente
interface TooltipButtonProps {
  label?: React.ReactNode; // Texto o elemento que se mostrará en el tooltip
  onClick?: () => void;     // Función al hacer click en el botón
  children?: React.ReactNode; // Contenido del botón
  className?: string;       // Clases CSS adicionales
  hidden?: boolean;         // Opción para ocultar el tooltip
  place?: "top" | "right" | "bottom" | "left"; // Posición del tooltip
}

const TooltipLogBlock: React.FC<TooltipButtonProps> = ({
  label,
  onClick,
  children,
  className,
  hidden,
  place = "top", // Valor por defecto
}) => {
  // Generar un ID único para el tooltip
  const tooltipId = `Tooltip-${typeof label === "string" || typeof label === "number"
      ? String(label).replace(/\s+/g, "-")
      : Math.random().toString(36).slice(2, 11)
    }`;

  return (
    <div className={`flex items-center ${className}`}> {/* Contenedor del botón y tooltip */}
      <button
        onClick={onClick} // Ejecuta función al hacer click
        className="flex items-center justify-center rounded-md"
        data-tooltip-id={tooltipId} // Vincula el botón con el tooltip
      >
        {children} {/* Contenido del botón */}
      </button>

      {!hidden && ( // Solo mostrar tooltip si no está oculto
        <Tooltip
          id={tooltipId}
          place={place}
          content={typeof label === "string" ? label : label?.toString() ?? ""}
          className={TooltipCss.tooltipCustom}
        />
      )}
    </div>
  );
};

export default TooltipLogBlock;